import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';

export const PHONE_FIELD_ELEMENT_TYPE = 'phonefield' as const;
export const PhoneFieldElementType = z.literal(PHONE_FIELD_ELEMENT_TYPE);

export const PhoneFieldParamsSchema = FieldSchema.extend({
  defaultCountry: z.string().optional(),
});

export type TPhoneFieldParams = z.infer<typeof PhoneFieldParamsSchema>;

export const PhoneFieldElementSchema = InitialUIElement.extend({
  element: PhoneFieldElementType,
  params: PhoneFieldParamsSchema,
  valueDestination: z.string(),
});
